import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TestLiveConstant } from 'src/app/constants/message-constant';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-test-dialog',
  templateUrl: './test-dialog.component.html',
  styleUrls: ['./test-dialog.component.scss']
})
export class TestDialogComponent {
  element: string = '';
  Name: string = '';
  testObj: any = {};
  testLiveConstant: any = [];
  isLive: boolean = false;
  constructor(public modalService: NgbActiveModal, private common: CommonService) {
    this.common.isSystemAlert = true;
  }
  ngOnInit(): void {
    this.testLiveConstant = TestLiveConstant;
    this.Name = this.testObj.testName;
    this.element = this.testObj.element;
    this.isLive = this.testObj.status;
  }
}
